<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormHerramienta" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objHerramienta.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>

                    <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Nombre">Stock Mínimo</label>
							<input @input="$onlyNums($event,objHerramienta,'MinimoStock')" type="text" v-model="objHerramienta.MinimoStock" class="form-control" id="MinimoStock" placeholder="Ingresar Stock Minimo" />
							<CValidation v-if="this.errorvalidacion.MinimoStock" :Mensaje="'*'+errorvalidacion.MinimoStock[0]"/>
						</div>

                        <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
							<label class="form-label" for="Nombre">Stock Máximo</label>
							<input @input="$onlyNums($event,objHerramienta,'MaximoStock')" type="text" v-model="objHerramienta.MaximoStock" class="form-control" id="MaximoStock" placeholder="Ingresar Stock Maximo" />
							<CValidation v-if="this.errorvalidacion.MaximoStock" :Mensaje="'*'+errorvalidacion.MaximoStock[0]"/>
						</div>
					</div>
					
					<!-- <div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Cantidad">Cantidad</label>
							<input type="text" v-model="objHerramienta.Cantidad" class="form-control" id="Cantidad" placeholder="Ingresar Cantidad" />
							<CValidation v-if="this.errorvalidacion.Cantidad" :Mensaje="'*'+errorvalidacion.Cantidad[0]"/>
						</div>
					</div> -->
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormHerramienta',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objHerramienta: {
				IdHerramienta: 0,
				Nombre: '',
				Cantidad: 0,
                MinimoStock:0,
                MaximoStock:0
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objHerramienta.IdHerramienta == 0) {
				await this.$http.post(
					'herramientas',this.objHerramienta
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'herramientas/'+this.objHerramienta.IdHerramienta,
					this.objHerramienta
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "herramientas/"+this.objHerramienta.IdHerramienta
            ).then((res) => {
                this.objHerramienta = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objHerramienta.Fecha.replace(/-/g,'\/');
                this.objHerramienta.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objHerramienta = {
				IdHerramienta: 0,
				Nombre: '',
				Cantidad: 0,
                MaximoStock:0,
                MinimoStock:0
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objHerramienta.IdHerramienta = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
